/* eslint-disable react-hooks/exhaustive-deps */
import { HiMenu, HiX } from 'react-icons/hi';
import { Link, NavLink } from 'react-router';
import useNavbar from './useNavbar';
import navLinks from './NavbarData';
import { motion } from 'framer-motion';

interface NavbarProps {
  sectionRef: React.RefObject<HTMLDivElement | null>;
}

export default function Navbar({ sectionRef }: NavbarProps) {
  const {
    isMenuOpen, scrolled, setIsMenuOpen, menuRef, handleScrollTo, closeMenu
  } = useNavbar();

  const renderNavLinks = (isMobile = false) => (
    navLinks.map((link) => (
      <NavLink
        key={link.label}
        to={link.href}
        onClick={isMobile ? () => {
          closeMenu();
          if (link.label === 'Funções') setTimeout(() => handleScrollTo(sectionRef), 200);
        } : () => { if (link.label === 'Funções') setTimeout(() => handleScrollTo(sectionRef), 200); }}
        className={({ isActive }) =>
          `relative px-3 py-2 text-sm font-semibold rounded-md transition-colors duration-300
           ${isMobile ? 'block w-full text-base' : 'flex items-center h-full'}
           ${isActive && link.label !== 'Funções' ? 'text-blue-600' : 'text-slate-600 hover:text-blue-600'}`
        }
      >
        {({ isActive }) => (
          <>
            <span className="relative z-10">{link.label}</span>
            {isActive && link.label !== 'Funções' && (
              <motion.div
                layoutId="active-nav-underline"
                className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"
              />
            )}
          </>
        )}
      </NavLink>
    ))
  );

  return (
    <nav
      className={`sticky top-0 z-50 bg-white h-14 transition-all duration-500 ${
        scrolled ? "shadow-xl" : "shadow-2xs"
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-14 items-center justify-between">
          <div className="flex items-center gap-10 h-full">
            <NavLink to="/">
              <img
                src="/logos/Logo Cores.svg"
                alt="Logo UnDesk"
                className="h-10"
              />
            </NavLink>
            <div className="hidden lg:flex items-center gap-6 h-full">
              {renderNavLinks()}
            </div>
          </div>

          <div className="hidden lg:flex lg:items-center lg:gap-6 h-full ">
            <Link
              to={
                import.meta.env.VITE_BETA_ENV
                  ? "https://beta-app.undesk.com.br/login"
                  : "https://app.undesk.com.br/login"
              }
              className="h-full flex items-center px-4 py-2 font-semibold text-gray-600 hover:text-blue-800 rounded-md"
            >
              Login
            </Link>
            <Link
              to={
                import.meta.env.VITE_BETA_ENV
                  ? "https://beta-app.undesk.com.br/register"
                  : "https://app.undesk.com.br/register"
              }
              className="h-full flex items-center bg-cobalt px-4 py-2 font-semibold text-white shadow-sm hover:bg-blue-800"
            >
              Teste Gratuitamente
            </Link>
          </div>

          <div className="flex items-center lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center rounded-md p-2 text-gray-600 hover:bg-gray-100 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
              aria-expanded={isMenuOpen}
            >
              <span className="sr-only">Abrir menu principal</span>
              {isMenuOpen ? (
                <HiX className="h-6 w-6" />
              ) : (
                <HiMenu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      <div
        id="mobile-menu"
        ref={menuRef}
        className={`
            lg:hidden bg-white absolute top-14 left-0 w-full shadow-lg
            transition-all duration-300 ease-in-out
            ${
              isMenuOpen
                ? "opacity-100 translate-y-0"
                : "opacity-0 -translate-y-full pointer-events-none"
            }
          `}
      >
        <div className="space-y-1 px-2 pt-2 pb-3 sm:px-3">
          {renderNavLinks(true)}
        </div>
        <div className="border-t border-gray-200 pt-4 pb-3">
          <div className="space-y-2 px-2">
            <Link
              to={
                import.meta.env.VITE_BETA_ENV
                  ? "https://beta-app.undesk.com.br/login"
                  : "https://app.undesk.com.br/login"
              }
              className="block rounded-md px-3 py-2 text-base font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800"
            >
              Login
            </Link>
            <Link
              to={
                import.meta.env.VITE_BETA_ENV
                  ? "https://beta-app.undesk.com.br/register"
                  : "https://app.undesk.com.br/register"
              }
              className="block w-full text-left bg-cobalt px-3 py-2 text-base font-semibold text-white shadow-sm hover:bg-blue-800"
            >
              Teste Gratuitamente
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
